import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Input, InputGroup, InputGroupText, Button } from 'reactstrap';
import { FaWrench, FaUser, FaSearch, FaGlobe, FaSteam } from 'react-icons/fa';
import PacmanLoader from 'react-spinners/PacmanLoader';
import TitleCard from './components/TitleCard';

function V7() {
  const [serverconfig, setServerconfig] = useState([]);
  const [loading, setLoading] = useState(true);
  const [foundServers, setFoundServers] = useState([]);
  const [search, setSearch] = useState('');

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.ohdservers.net/api/allservers');
      const resultData = await response.json();
      if (resultData.state !== 'error') {
        setServerconfig(resultData);
        setFoundServers(resultData);
      }
    } catch (error) {
      setServerconfig({ state: 'error', msg: 'Server info could not be retrieved. ' + error });
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData();
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const handleSearch = (e) => {
    const keyword = e.target.value;
    setSearch(keyword);
    if (keyword === '') {
      setFoundServers(serverconfig);
    } else {
      const results = serverconfig.filter((s) =>
        s.name.toLowerCase().includes(keyword.toLowerCase()) ||
        s.map.toLowerCase().includes(keyword.toLowerCase())
      );
      setFoundServers(results);
    }
  };

  return (
    <div style={{ background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.98), rgba(15, 23, 42, 1))', minHeight: '100vh', width: '100%', maxWidth: '100%' }}>
      <Container fluid className="py-3" style={{ paddingLeft: '8px', paddingRight: '8px' }}>
        <Row className="align-items-center g-3 mb-3">
          <Col md={3} className="d-none d-md-block">
            <h5 style={{ color: '#f1f5f9', fontWeight: '700' }}>
              O:HD Servers
            </h5>
          </Col>
          <Col xs={12} md={6}>
            <InputGroup>
              <InputGroupText style={{
                background: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.2)',
                color: '#fbbf24',
              }}>
                <FaSearch />
              </InputGroupText>
              <Input
                style={{
                  background: 'rgba(255,255,255,0.08)',
                  border: '1px solid rgba(255,255,255,0.15)',
                  color: '#fff',
                  backdropFilter: 'blur(10px)',
                }}
                placeholder="Search servers by name or map..."
                value={search}
                onChange={handleSearch}
              />
            </InputGroup>
          </Col>
          <Col xs={12} md={3} className="d-flex justify-content-end gap-2">
            <Button
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.2)',
                color: '#fbbf24',
              }}
              href="/serversetup"
              title="Server Setup"
            >
              <FaWrench size={18} />
            </Button>
            <Button
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.2)',
                color: '#94a3b8',
              }}
              href="/about"
              title="About"
            >
              <FaUser size={18} />
            </Button>
            <Button
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.2)',
                color: '#22c55e',
              }}
              href="https://store.steampowered.com/app/736590/Operation_Harsh_Doorstop/"
              target="_blank"
              title="Get O:HD Free on Steam"
            >
              <FaGlobe size={18} />
            </Button>
            <Button
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.2)',
                color: '#22c55e',
              }}
              href="https://steamcommunity.com/app/736590/workshop/"
              target="_blank"
              title="Steam Workshop"
            >
              <FaSteam size={18} />
            </Button>
          </Col>
        </Row>

        {loading ? (
          <div className="text-center py-5">
            <PacmanLoader color="#fbbf24" loading={true} size={35} />
            <p style={{ color: '#94a3b8', marginTop: '1rem' }}>
              Loading servers...
            </p>
          </div>
        ) : foundServers && foundServers.length > 0 ? (
          <>
            <TitleCard servers={foundServers} />
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '12px 16px',
                marginTop: '8px',
                background: 'rgba(15, 23, 42, 0.6)',
                borderRadius: '8px',
                fontSize: '0.75rem',
                color: '#64748b',
              }}
            >
              <span>Showing {foundServers.length} of {serverconfig.length} servers</span>
              <span style={{ color: '#fbbf24' }}>Click to connect</span>
            </div>
          </>
        ) : (
          <div className="text-center py-5">
            <h5 style={{ color: '#94a3b8' }}>
              No servers found
            </h5>
          </div>
        )}
      </Container>
    </div>
  );
}

export default V7;
